import { render, staticRenderFns } from "./Parties.vue?vue&type=template&id=da81df8e"
import script from "./Parties.vue?vue&type=script&lang=js"
export * from "./Parties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports